export default __webpack_public_path__ + "static/media/cancel.48686e42.svg";